import {createAction} from 'redux-actions';
import {POPUP_CLOSE, POPUP_OPEN} from '../action-types';

export const close = createAction(POPUP_CLOSE);
export const open = createAction(POPUP_OPEN, (content, options = {}) => ({
	content,
	options
}));
